export default class Locale_MoveAllResourceRequestsDialog { 
	FailedMovingRequests: string = "Failed moving requests";
	DialogTitle: string = "Move all requests to";
	SubTextSuccess: string = "Succesfully moved all requests";
	SubText: string = "Select a resource to move the requests to.";
}